import { ThunkAction } from 'redux-thunk';
import { CheckoutState } from '../../state';
import { updateBraintreeClientTokenAction } from './actions';
import { getBraintreeClientToken } from './getBraintreeClientToken';

export const getAndSetBraintreeToken =
    (): ThunkAction<Promise<string>, CheckoutState, void> =>
    async (dispatch, getState) => {
        const order = getState().order;

        const braintreeClientToken =
            'braintreeClientToken' in order
                ? order.braintreeClientToken
                : (await dispatch(getBraintreeClientToken())).response
                      .client_token;

        await dispatch(updateBraintreeClientTokenAction(braintreeClientToken));

        return braintreeClientToken;
    };
